<template>
  <div class="category" :class="[
    { 'animate__animated animate__zoomOutLeft': isDeleting },
    { 'category--deleting': wasDeleted },
  ]">
    <span class="category__name">
      <span @click.self="showCategoryNamePopup = true">
        <transition name="fade" mode="in-out">
          <PopupEditer v-if="showCategoryNamePopup" @togglePopup="showCategoryNamePopup = $event"
            :selected="category.name" @submit="updateModelCategoryName($event)" />
        </transition>
        {{ category.name }}
      </span>
    </span>
    <div class="icon icon__delete" @click="deleteModelCategory()"></div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useStore } from "vuex";
import PopupEditer from "@/partials/PopupEditer";

defineOptions({
  name: "ModelCategory"
});

const props = defineProps({
  category: {
    required: true,
    type: Object,
  },
  getModels: {
    required: true,
    type: Function,
  },
});

const store = useStore();

// State
const isDeleting = ref(false);
const wasDeleted = ref(false);
const showCategoryNamePopup = ref(false);

// Methods
const deleteModelCategory = async () => {
  isDeleting.value = true;
  await store.dispatch("deleteModelCategory", props.category.id);
  wasDeleted.value = true;

  setTimeout(async () => {
    await props.getModels();
  }, 300);
};

const updateModelCategoryName = async (name) => {
  await store.dispatch("updateModelCategory", {
    name,
    modelId: props.category.model_id,
    categoryId: props.category.id,
  });
  await props.getModels();
};
</script>